module.exports = __webpack_public_path__ + "img/inter01.8c57b5f0.jpg";